import React from "react";
import CommanBanner from "../../CommanComponent/CommanBanner/CommanBanner";
const AboutUsBanner = () => {
  return (
    <>
      <section className="About-banner">
        <div>
          <CommanBanner
            VideoPath={process.env.PUBLIC_URL + "/assets/video/home-video.mp4"}
            imgClassName="d-none"
            FirstHeading={"About Us"}
            SecondHeading="Delivering Excellence in Every Detail"
            buttonName="d-none"
          />
        </div>
      </section>
    </>
  );
};

export default AboutUsBanner;
